import React from 'react';
import { Link } from 'react-router-dom';

// Components
import {Box, Button, Columns, Section } from 'react-bulma-components';

const Settings = () => {

    return (
        <section>
            <h1 style={{ padding: '3rem 3rem 1rem 3rem'}}>Settings</h1>
            <Columns className="section">
                <Columns.Column>
                    <Box>
                        <Section>
                            <h2 style={{ marginBottom: '3rem'}}>User Management</h2>
                            <Button.Group>
                                <Button renderAs={Link} to="users">
                                    See All Users
                                </Button>
                            </Button.Group>
                        </Section>
                    </Box>
                </Columns.Column>
                <Columns.Column>
                <Box>
                    <Section>
                        <h2 style={{ marginBottom: '3rem'}}>Application Settings</h2>
                        <hr />
                        <hr />
                    </Section>
                </Box>
                </Columns.Column>
            </Columns>
        </section>
    );
}

export default Settings;
